import React from 'react';
import { Accordion} from 'react-bootstrap';

import TournoisParticiper from './participerTournois';

function TournoisAffichageParticiper(props) {

  return (
    <>
    <Accordion defaultActiveKey="0">
    {props.tournoisPasInscrit && props.tournoisPasInscrit.map((item,index) => (
                        <Accordion.Item key={index}  eventKey={index}>
                            <TournoisParticiper item={item} userData={props.userData}/>
                    </Accordion.Item>
            ))}

    </Accordion><br/>

    </>
  );
}

export default TournoisAffichageParticiper;